module.exports = __webpack_public_path__ + "static/media/  (89).edb90948.jpg";